import React, {useEffect, useState} from 'react';
import ResizableBox, {radarOptions} from "../../utils/ResizableBox";
import {Radar} from 'react-chartjs-2';
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {Backdrop, Card, CardContent, CardHeader, CircularProgress, TextField, Typography} from "@mui/material";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {spAslCodeWithColor} from "../../../../../utils/dictionaries/Generics";
import clsx from "clsx";
import { Autocomplete } from '@mui/material';
import {categoriesV2} from "../../../../../utils/dictionaries/Categories";
import {PaperComponent} from "../../../../../styles/components/DynamicComponentStyle";

export const TicketCategoriaAsl = ({dataGrafico1}) => {
	const classes = BaseStyle();
	const [loading, setLoading] = useState(false);
	const [filters, setFilters] = useState(
		['Vaccinazioni', 'Covid 19', 'Tamponi', 'Tamponi rapidi', 'Isolamento (Caso positivo)', 'Quarantena (Contatto)', 'Comunità', 'Rientro in Italia', 'Certificazione verde COVID-19', 'Scuole']
	)

	const [data, setData] = useState({
		labels: ['Vaccinazioni', 'Covid 19', 'Tamponi', 'Tamponi rapidi', 'Isolamento (Caso positivo)', 'Quarantena (Contatto)', 'Comunità', 'Rientro in Italia', 'Certificazione verde COVID-19', 'Scuole'],
		datasets: [
			{
				label: 'ASL 301',
				data: [2, 9, 3, 5, 2, 2, 3, 4, 5, 8],
				backgroundColor: 'rgba(255, 99, 132, 0.2)',
				borderColor: 'rgba(255, 99, 132, 1)',
				borderWidth: 1,
			},
		],
	})

	useEffect(() => {
		setLoading(true)
		axios
			.get(BASE_NAME + "ticket/getStatsByCategoriesAndASL/" + moment(dataGrafico1).format("DD-MM-YYYY"), getConfig())
			.then((response) => {

				let newData = {
					labels: response.data.filter(dataItem => filters.includes(dataItem.label)).map(item => item.label),
					datasets:
						Object.entries(spAslCodeWithColor).map(([key, val]) => {
							return {
								label: val.label,
								data: response.data.filter(dataItem => filters.includes(dataItem.label)).map(elem => elem.data[key]),
								backgroundColor: val.transparentCol,
								borderColor: val.color,
								borderWidth: 1,
							}
						})
				}
				setData(newData);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico1, filters])

	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>

			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Ticket categoria - ASL</b></Typography>}
					subheader={"Numero di ticket per categoria (punte del radar) per ASL (colore)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>

					<ResizableBox width={800} height={800}>
						<Radar data={data} type={"radar"} options={radarOptions}/>
					</ResizableBox>

					<Autocomplete
						value={filters}
						onChange={(event, newValue) => {
							setFilters(newValue);
						}}
						multiple={true}
						id="controllable-states-demo"
						options={Object.entries(categoriesV2).map(([, val]) => val.label)}
						PaperComponent={PaperComponent}
						style={{width: "100%"}}
						renderInput={(params) => <TextField {...params} label="Filtri" variant="outlined"/>}
					/>

				</CardContent>
			</Card>

		</React.Fragment>
	);
};
